<div
  #sectionItem
  class="product-container"
  id="product-container-m{{ menu.id }}-s{{ sectionIndex }}-i{{ itemIndex }}"
  [ngClass]="[
    rowViewModel
      | method: 'getReadableStrainType' : Types.SectionColumnConfigDataForStrainTypeColumn.StrainTypeWord
      | lowercase,
    menu | method: 'getProductWrapperClass' : odd
  ]"
  [class.odd]="odd"
  [class.even]="!odd"
  [class.first]="first"
  [class.last]="last"
  [class.force-bold-style]="viewModel.forcedRowBoldStyling$ | async"
  [class.force-italic-style]="viewModel.forcedRowItalicStyling$ | async"
  [class.has-background-color]="viewModel.rowBackgroundColor$ | async | getArrayElementAtIndex: 1"
  [ngStyle]="viewModel.productWrappingStyle$ | async"
  [style.background-color]="viewModel.rowBackgroundColor$ | async | getArrayElementAtIndex: 1"
  [style.color]="viewModel.forcedRowTextColorToDisplay$ | async"
  [style.text-decoration-color]="viewModel.forcedRowTextColor$ | async"
  [style.zoom]="viewModel.forcedRowZoom$ | async"
  [style.border-color]="viewModel.sectionBorderColor$ | async">
  <ng-container *ngFor="let colVm of viewModel.columnViewModels$ | async">
    <!--    Lay out product title column    -->
    <div
      *ngIf="colVm.columnType === Types.SectionColumnProductInfoType.ProductTitle"
      [class.default-background-color]="!(viewModel | columnBackgroundColor: colVm | async)"
      class="product-title-container">
      @let fixedLocationViewModels = viewModel.fixedLocationViewModels$ | async;
      @let strainType =
        (menu | method: 'fixedLocationStrainTypePropertyIsWithin') === Types.WithinNameCell.TitleLine &&
        (menu | method: 'isFixedLocationStrainTypePropertyCellVisible' : fixedLocationViewModels) &&
        (rowViewModel | method: 'getReadableStrainType' : colVm?.strainTypeMode);
      @let brand =
        (menu | method: 'fixedLocationBrandPropertyIsWithin') === Types.WithinNameCell.TitleLine &&
        (menu | method: 'isFixedLocationBrandPropertyCellVisible' : fixedLocationViewModels) &&
        (rowViewModel | method: 'getBrand');
      <div class="flex-container product-title-flex-container">
        <div
          *ngIf="strainType"
          [ngStyle]="{ 'background-color': rowViewModel | method: 'getStrainTypeColor' }"
          class="base-product-strain-type">
          {{ strainType }}
        </div>
        <div *ngIf="brand" class="product-brand">
          {{ brand }}
        </div>
        <div class="product-title">{{ rowViewModel | method: 'getRowTitle' }}</div>
        <app-label-inflator
          *ngIf="(menu | method: 'getShowInlineLabels') === Types.WithinNameCell.TitleLine && !rowViewModel.hideLabel"
          class="product-label-container"
          [labelComponentInterface]="rowViewModel">
        </app-label-inflator>
      </div>
      @let subtitleStrainType =
        (menu | method: 'fixedLocationStrainTypePropertyIsWithin') === Types.WithinNameCell.SubtitleLine &&
        (menu | method: 'isFixedLocationStrainTypePropertyCellVisible' : fixedLocationViewModels) &&
        (rowViewModel | method: 'getReadableStrainType' : colVm?.strainTypeMode);
      @let subtitleBrand =
        (menu | method: 'fixedLocationBrandPropertyIsWithin') === Types.WithinNameCell.SubtitleLine &&
        (menu | method: 'isFixedLocationBrandPropertyCellVisible' : fixedLocationViewModels) &&
        (rowViewModel | method: 'getBrand');
      @let subtitle = (menu | method: 'getShowProductSubtitle') && (rowViewModel | method: 'getProductSubtitle');
      @let subtitleLabel =
        (menu | method: 'getShowInlineLabels') === Types.WithinNameCell.SubtitleLine && !rowViewModel.hideLabel;
      <div *ngIf="subtitleStrainType || subtitle || subtitleLabel" class="flex-container subtitle-flex-container">
        <div
          *ngIf="subtitleStrainType"
          [ngStyle]="{ 'background-color': rowViewModel | method: 'getStrainTypeColor' }"
          class="base-product-strain-type">
          {{ subtitleStrainType }}
        </div>
        <div *ngIf="subtitleBrand" class="product-brand">
          {{ subtitleBrand }}
        </div>
        <div *ngIf="subtitle" class="product-subtitle">
          {{ subtitle }}
        </div>
        <app-label-inflator
          *ngIf="subtitleLabel"
          class="product-label-container"
          [labelComponentInterface]="rowViewModel">
        </app-label-inflator>
      </div>
    </div>

    <app-column-wrapper
      [menu]="menu"
      [section]="section"
      [colVm]="colVm"
      [rowVm]="rowViewModel"
      [locConfig]="locationConfig"
      [locationId]="locationId"
      [productStylingVm]="viewModel">
      @if (colVm.columnType === Types.SectionColumnProductInfoType.VariantPrice) {
        <app-column-primary-price
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [forceNgContentToBeShownAfterPriceContent]="true">
          <div *ngIf="section | method: 'isInLineMode'; else gridPrice" class="product-variant-price-secondary">
            {{ rowViewModel | method: 'getSize' }}
          </div>
          <ng-template #gridPrice>
            <div class="product-variant-price-secondary">
              {{ menu | method: 'getPriceColumnTitle' : colVm }}
            </div>
          </ng-template>
        </app-column-primary-price>
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.VariantSecondaryPrice) {
        <app-column-secondary-price
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.QuantityAndSize) {
        <app-column-quantity-and-size
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.QuantityAndSize) {
        <app-column-quantity-and-size
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [useNgContent]="true">
          {{ rowViewModel | method: 'getQuantityAndSizeString' }}
          <div class="product-quantity-and-size-secondary">{{ colVm.columnTitle }}</div>
        </app-column-quantity-and-size>
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Quantity) {
        <app-column-quantity
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [useNgContent]="true">
          <div>{{ rowViewModel | method: 'getQuantityString' }}</div>
          <div class="product-quantity-secondary">{{ colVm.columnTitle }}</div>
        </app-column-quantity>
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.StrainType) {
        <app-column-strain-type
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [useNgContent]="true">
          {{ rowViewModel | method: 'getReadableStrainType' : colVm.strainTypeMode }}
          <div class="product-strain-type">{{ colVm.columnTitle }}</div>
        </app-column-strain-type>
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Producer) {
        <app-column-producer
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [useNgContent]="true">
          <div>{{ (rowViewModel | method: 'getBrand') || '&nbsp;' }}</div>
          <div class="product-producer-secondary">{{ colVm.columnTitle }}</div>
        </app-column-producer>
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Brand) {
        <app-column-brand
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [useNgContent]="true">
          <div>{{ rowViewModel | method: 'getBrand' }}</div>
          <div class="product-brand-secondary">{{ colVm.columnTitle }}</div>
        </app-column-brand>
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Spacer) {
        <app-column-spacer
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.TinySpacer) {
        <app-column-tiny-spacer
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Badge) {
        <app-column-badge
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Lineage) {
        <app-column-lineage
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Aroma) {
        <app-column-aroma
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Appearance) {
        <app-column-appearance
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.GrowingConditions) {
        <app-column-growing-conditions
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.CraftDesignation) {
        <app-column-craft-designation
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.TopFlavor) {
        <app-column-top-flavor
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [displayFormat]="colVm?.columnConfig?.dataValue" />
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Flavor) {
        <app-column-flavor
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm" />
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.EnergyScore) {
        <app-column-energy-score
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [displayFormat]="colVm?.columnConfig?.dataValue" />
      } @else if (colVm.columnType === Types.SectionColumnProductInfoType.GradingResults) {
        <app-column-grading-results
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel" />
      } @else if (colVm.columnType | isCannabinoidColumn) {
        <app-column-cannabinoid
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [cannabinoidColumnType]="colVm.columnType | isCannabinoidColumn"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm"
          [useNgContent]="true">
          <div>
            {{
              rowViewModel
                | method: 'getCannabinoid' : (colVm.columnType | isCannabinoidColumn) : colVm?.columnConfig?.dataValue
            }}
          </div>
          <div class="product-cannabinoid-secondary">{{ colVm.columnTitle }}</div>
        </app-column-cannabinoid>
      } @else if (colVm.columnType | isTerpeneColumn) {
        <app-column-terpene
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [terpeneColumnType]="colVm.columnType | isTerpeneColumn"
          [displayFormat]="colVm?.columnConfig?.dataValue"
          [columnListLayoutModifierClass]="this | method: 'getLayoutModifierClassForListColumn' : colVm"
          [useNgContent]="true">
          <div>
            {{
              (colVm.columnType | isTerpeneColumn) === Types.SectionColumnTerpeneType.TopTerpene
                ? (rowViewModel | method: 'getTopTerpene')
                : (rowViewModel
                  | method: 'getTerpene' : (colVm.columnType | isTerpeneColumn) : colVm?.columnConfig?.dataValue)
            }}
          </div>
          <div class="product-terpene-secondary">{{ colVm.columnTitle }}</div>
        </app-column-terpene>
      } @else if (colVm.columnType | isProductTagGroupColumn) {
        <app-column-product-tag-group
          [menu]="menu"
          [section]="section"
          [colVm]="colVm"
          [rowVm]="rowViewModel"
          [locConfig]="locationConfig"
          [locationId]="locationId"
          [productStylingVm]="viewModel"
          [productTagGroupColumnType]="colVm.columnType | isProductTagGroupColumn" />
      }
    </app-column-wrapper>
  </ng-container>
</div>
